export const form = `
{% if (ctx.options.vpat) { %}
  <span tabindex="-1" class="sr-only" id="invisible-{{ctx.instance.id}}-{{ctx.component.key}}"></span>
{% } %}

  {% if (ctx.options.vpat) { %}
    <div>{{(!ctx.component.filePattern || ctx.component.filePattern === '*') ? 'Any file types are allowed' : ctx.t('Allowed file types: ') + ctx.component.filePattern}}</div>
  {% } %}
  <div class="files">
    {% ctx.files.forEach(function(file) { %}
      <div class="file-wrapper">
        <div class="file" data-url="{{file.url?.replace('/' + file.name, file?.data?.file?.uuid || file?.name)?.replace("form", "fileUuid")}}" data-type="{{file.type}}" data-name="{{file.name}}" data-original-name="{{file.originalName}}">
          
        <div class="file__thumbnail" style="{{ (file.type && file.type.indexOf('image')) > -1 ? 'background-image: url(' + encodeURI(file.url?.replace('/' + file.name, file?.data?.file?.uuid || file?.name)?.replace("form", "fileUuid")) + ');' : '' }}">

          </div>

          <div class="file__overlay">
            {% if (!ctx.disabled) { %}
              <div class="file__overlay-header">
                <div class="file-remove" ref="removeLink"><i tabindex="0" class="{{ctx.iconClass('remove')}}" ></i></div>
              </div>
            {% } %}
            <div class="file__overlay-body">
              {% if (ctx.component.uploadOnly) { %}
                {{file.originalName || file.name}}
              {% } else { %}
                <a class="download-file-link" href="{{file.url?.replace("form", "fileUuid") || '#'}}" target="_blank" ref="fileLink" download="{{file.originalName || file.name}}">
                  <img class="download-file-link__image" src="data:image/jpeg;base64,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" />
                </a>
              {% } %}
            </div>
          </div>
        </div>
        <div class="file__footer">
          <div class="file-type file-type__{{file.type && file.type.split('/')[0]}}"></div>
          <div class="file-name">
            {{file.originalName || file.name}}
          </div>
        </div>
      </div>
    {% }) %}
  </div>
{% if (!ctx.disabled && (ctx.component.multiple || !ctx.files.length)) { %}
  {% if (ctx.self.useWebViewCamera) { %}
    <div class="fileSelector">
      <button class="btn btn-primary" ref="galleryButton"><i class="fa fa-book"></i> {{ctx.t('Gallery')}}</button>
      <button class="btn btn-primary" ref="cameraButton"><i class="fa fa-camera"></i> {{ctx.t('Camera')}}</button>
    </div>
  {% } else if (!ctx.self.cameraMode) { %}
    <div class="fileSelector" ref="fileDrop" {{ctx.fileDropHidden ?'hidden' : ''}}>
      <i class="{{ctx.iconClass('cloud-upload')}}"></i> {{ctx.t('Drop files to attach,')}}
        {% if (ctx.self.imageUpload && ctx.component.webcam) { %}
          <a href="#" ref="toggleCameraMode"><i class="fa fa-camera"></i> {{ctx.t('use camera')}}</a>
        {% } %}
        {{ctx.t('or')}}
        <a href="#" ref="fileBrowse" class="browse">
          {{ctx.t('browse')}}
          <span class="sr-only">
            {{ctx.t('Browse to attach file for ' + ctx.component.label + '. ' + 
            (ctx.component.description ? ctx.component.description + '. ' : '') + 
            ((!ctx.component.filePattern || ctx.component.filePattern === '*') ? 'Any file types are allowed' : ctx.t('Allowed file types: ') + ctx.component.filePattern))}}
          </span>
        </a>
      <div ref="fileProcessingLoader" class="loader-wrapper">
        <div class="loader text-center"></div>
      </div>
    </div>
  {% } else { %}
    <div class="video-container">
      <video class="video" autoplay="true" ref="videoPlayer" tabindex="-1"></video>
    </div>
    <button class="btn btn-primary" ref="takePictureButton"><i class="fa fa-camera"></i> {{ctx.t('Take Picture')}}</button>
    <button class="btn btn-primary" ref="toggleCameraMode">{{ctx.t('Switch to file upload')}}</button>
  {% } %}
{% } %}
{% ctx.statuses.forEach(function(status) { %}
  <div class="file {{ctx.statuses.status === 'error' ? ' has-error' : ''}}">
    <div class="row">
      <div class="fileName col-form-label col-sm-10">{{status.originalName}}
        <i class="{{ctx.iconClass('remove')}}" ref="fileStatusRemove">
          <span class="sr-only">{{ctx.t('Remove button. Press to remove ' + status.originalName || status.name + '.')}}</span>
          <span class="sr-only">{{status.message ? status.message?.replace(';', '.') : ''}}</span>
        </i>
      </div>
      <div class="fileSize col-form-label col-sm-2 text-right">{{ctx.fileSize(status.size)}}</div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        {% if (status.status === 'progress') { %}
          <div class="progress">
            <div class="progress-bar" role="progressbar" aria-valuenow="{{status.progress}}" aria-valuemin="0" aria-valuemax="100" style="width: {{status.progress}}%">
              <span class="sr-only">{{status.progress}}% {{ctx.t('Complete')}}</span>
            </div>
          </div>
        {% } else if (status.status === 'error') { %}
          <div class="alert alert-danger bg-{{status.status}}">{{ctx.t(status.message)}}</div>
        {% } else { %}
          <div class="bg-{{status.status}}">{{ctx.t(status.message)}}</div>
        {% } %}
      </div>
    </div>
  </div>
{% }) %}
{% if (!ctx.component.storage || ctx.support.hasWarning) { %}
  <div class="alert alert-warning">
    {% if (!ctx.component.storage) { %}
      <p>{{ctx.t('No storage has been set for this field. File uploads are disabled until storage is set up.')}}</p>
    {% } %}
    {% if (!ctx.support.filereader) { %}
      <p>{{ctx.t('File API & FileReader API not supported.')}}</p>
    {% } %}
    {% if (!ctx.support.formdata) { %}
      <p>{{ctx.t("XHR2's FormData is not supported.")}}</p>
    {% } %}
    {% if (!ctx.support.progress) { %}
      <p>{{ctx.t("XHR2's upload progress isn't supported.")}}</p>
    {% } %}
  </div>
{% } %}`;
